import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Pencil, Plus, Trash } from "@phosphor-icons/react/dist/ssr";

const tableConfig: FinalTableConfig = {
  index: null,
  actions: [
    {
      name: TableAction.CREATE,
      label: "create",
      showLabel: true,
      allowed: true,
      show: true,
      action: null,
      icon: <Plus size={20} />,
    },
  ],
  rowActions: [
    {
      name: RowAction.EDIT,
      label: "edit",
      icon: <Pencil size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("edit", element);
      },
    },
    {
      name: RowAction.DELETE,
      label: "delete",
      icon: <Trash size={20} />,
      allowed: true,
      show: true,
      action: (element: any) => {
        console.log("delete", element);
      },
    },
  ],
  rowConfiguration: {
    class: (element: any) => {
      return "";
    },
  },
  columns: [
    {
      name: "id",
      label: "#",
      key: "id",
      type: "number",
      show: true,
      allowOrder: true,
    },
    {
      name: "code",
      label: "code",
      key: "code",
      type: "string",
      show: true,
      allowOrder: true,
    },
    {
      name: "status",
      label: "status",
      key: "status.value",
      type: "translation",
      translation_prefix: "coupon_status",
      show: true,
      allowOrder: true,
    },
    {
      name: "initial_amount",
      label: "initial_amount",
      key: "initial_amount",
      type: "percentage",
      show: true,
      allowOrder: true,
    },
    {
      name: "producer",
      label: "producer",
      key: "producer.user.name",
      type: "string",
      show: true,
      allowOrder: true,
    },
  ],
  pagination: {
    enabled: true,
    back: true,
  },
};
const getConfig: any = (functions: any) => {
  const {
    getFunction,
    indexFunction,
    initializeFunction,
    prepareRemoveFunction,
  } = functions;
  tableConfig.actions[0].action = () => initializeFunction();
  // tableConfig.actions[1].action = () => indexFunction();
  tableConfig.index = () => indexFunction();
  tableConfig.rowActions[0].action = (id: any) => getFunction(id);
  tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
  return tableConfig;
};
export default getConfig;
